import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../common';
import { NumberToWordsPipe } from './number-to-words.pipe';

@Pipe({
  name: 'dateToWords'
})
export class DateToWordsPipe implements PipeTransform {

  constructor(private numberToWordsPipe: NumberToWordsPipe){}

  transform(value: Date | string | number, ...args: string[]): any {
    if(!value) return '';
    let date: Date = new Date(value); 
    return this.numberToWordsPipe.transform(date.getDate(), {type:'date'}) + ' DE ' + Constants.Months[date.getMonth()] + ' DEL ' + this.numberToWordsPipe.transform(date.getFullYear());
  }

}
